import { getApiUrl } from '../config/api';

type CachedUrl = { url: string; expiresAt: number };

const cache = new Map<string, CachedUrl>();
const REFRESH_BUFFER_MS = 30_000;

export function invalidatePresignedPdfUrl(bucketKey: string): void {
  cache.delete(bucketKey);
}

export async function getPresignedPdfUrl(
  bucketKey: string,
  token: string,
  forceRefresh = false,
): Promise<string> {
  if (forceRefresh) {
    cache.delete(bucketKey);
  }

  const cached = cache.get(bucketKey);
  if (cached && cached.expiresAt - Date.now() > REFRESH_BUFFER_MS) {
    return cached.url;
  }

  const response = await fetch(
    `${getApiUrl('/pdf-presigned-url')}?bucket_key=${encodeURIComponent(bucketKey)}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to get document URL (${response.status})`);
  }

  const data = (await response.json()) as { url: string; expiresIn: number };
  cache.set(bucketKey, {
    url: data.url,
    expiresAt: Date.now() + data.expiresIn * 1000,
  });
  return data.url;
}
